(function () {
'use strict';

var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	};

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
			$(window).on('resize', this.setVw);
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

		setVw() {
			let vw = document.documentElement.clientWidth / 100;
			document.documentElement.style.setProperty('--vw', `${vw}px`);
		}

	}

})(jQuery);

var documentInit$1 = documentInit;

var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$trigger = $(selectors.trigger);
			this.$links = $('a', this.$container).not(this.$trigger).not('[href="#"]');
			this.$dropdownTrigger = $('a', this.$container).filter('[href="#"]');


			$('li', this.$navContainer).filter((i, el) => { return ($(el).children('a[href="#"]').length > 0 && $(el).children('.sub-menu').children().length > 0 && $(el).closest('.sub-menu').length == 0); }).children('a').append('<div class="c-nav__item-arrow">');
		}

		bind() {

			const self = this;

			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
			this.$dropdownTrigger.click(function () { self.toggleDropdown($(this)); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

		toggleDropdown($link) {
			if ($(window).width() < 900)
				$link.siblings('.sub-menu').stop().slideToggle(200);
		}

	}

})(jQuery);


var mobileNavInit$1 = mobileNavInit;

var navInit;

(function ($) {

	const selectors = {
		navContainer: '.c-nav',
	};

	navInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new Nav(el);
		});
	};

	class Nav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$items = $(this.$container).children('li');
		}

		bind() {
			const self = this;
			this.onHover = this.onHover.bind(this);
			this.onHoverOut = this.onHoverOut.bind(this);
			this.$items.hover(function (e) { self.onHover(this); }, function (e) { self.onHoverOut(this); });
		}

		onHover(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeIn();
		}

		onHoverOut(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeOut();
		}

	}

})(jQuery);


var navInit$1 = navInit;

var noUiSliderInit;

(function ($) {

	const selectors = {
		slider: '[data-range-input]',
		min_input: '[data-range-input-min]',
		max_input: '[data-range-input-max]',
	};

	noUiSliderInit = function () {
		$(selectors.slider).each((i, el) => {
			new NoUiSlider(el);
		});
	};

	class NoUiSlider {
		constructor(element) {
			this.$slider = $(element);

			if (this.$slider.length) {
				this.init();
			}

		}

		init() {

			const self = this;

			self.$wrap = this.$slider.parent();
			self.$min_input = $(selectors.min_input, self.$wrap);
			self.$max_input = $(selectors.max_input, self.$wrap);

			self.range = {
				'min': parseFloat(self.$slider.attr('min')),
				'max': parseFloat(self.$slider.attr('max'))
			};

			var current_values = [parseFloat(self.$min_input.val()) || self.range.min, parseFloat(self.$max_input.val()) || self.range.max];

			self.suffix = self.$slider.attr('data-suffix');

			self.nouislider = noUiSlider.create(self.$slider.get(0), {
				start: current_values,
				tooltips: [wNumb({ thousand: ' ', decimals: 0, suffix: self.suffix }), wNumb({ thousand: ' ', decimals: 0, suffix: self.suffix })],
				step: parseInt(self.$slider.attr('step')) || 1,
				connect: true,
				range: self.range
			});

			self.nouislider.on('update', function (values, handle) {
				self.$min_input.val(values[0]);
				self.$max_input.val(values[1]);

				const current_min = (parseFloat(values[0]) - self.range.min) / (self.range.max - self.range.min);
				const current_max = (parseFloat(values[1]) - self.range.min) / (self.range.max - self.range.min);

				if (current_min < 0.2 || values[0] == self.range.min) {
					self.$slider.addClass('at-start');
				}
				else {
					self.$slider.removeClass('at-start');
				}

				if (current_max > 0.8 || values[1] == self.range.max) {
					self.$slider.addClass('at-end');
				}
				else {
					self.$slider.removeClass('at-end');
				}

			});

		}
	}

})(jQuery);


var noUiSliderInit$1 = noUiSliderInit;

var tabsInit;

(function ($) {

	const selectors = {
		wrapper: '[data-tabs]',
		links: '[data-tabs-link]',
		tabs: '[data-tabs-tab]',
	};

	tabsInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Tabs(el);
		});
	};

	class Tabs {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$tabLinks = $(selectors.links, this.$wrapper);
			this.$tabs = $(selectors.tabs, this.$wrapper);

			this.animate = true;
			this.duration = 700;

			this.bind();

		}
		bind() {
			const self = this;

			self.onTabLinkClicked = self.onTabLinkClicked.bind(self);
			self.$tabLinks.click(self.onTabLinkClicked);

			$(document).on('hp-plugins-loaded', () => {
				self.switchTab('#' + self.$tabs.eq(0).attr('id'), false);
			});

		}

		onTabLinkClicked(e) {
			e.preventDefault();

			const self = this;
			const $link = $(e.target);

			self.switchTab($link.attr('href'));
		}

		switchTab(targetId, animate) {
			if (!targetId) return;

			const self = this;
			const $targetTab = self.$tabs.filter(targetId).eq(0);
			if (animate === undefined) animate = self.animate;

			if ($targetTab.hasClass('is-active')) return;

			$(document).trigger('switching-to-tab', { targetId: targetId, $targetTab: $targetTab });

			self.$tabLinks.removeClass('is-active').filter((i, el) => { return $(el).attr('href') === targetId }).addClass('is-active');

			self.$tabs.removeClass('is-active');
			$targetTab.addClass('is-active');

			if (animate) {

				const $curTab = self.$tabs.filter(':visible');
				const curHeight = $curTab.eq(0).outerHeight();

				$curTab.css('position', 'absolute');
				$targetTab.css('opacity', 0).show();

				const newHeight = $targetTab.outerHeight();

				$curTab.stop().animate({ 'opacity': 0 }, self.duration, function () {
					$(this).hide().css({ 'position': '', opacity: '' });
				});

				$targetTab.css('height', curHeight).stop().animate({ 'height': newHeight, 'opacity': 1 }, self.duration, function () {
					$(this).css({ 'height': '', 'opacity': '' });
				});

			}
			else {
				self.$tabs.hide();
				$targetTab.show();
			}

		}

	}

})(jQuery);


var tabsInit$1 = tabsInit;

var scrollDetectorInit;

(function ($) {

	const selectors = {
		element: '[data-detect-scroll]',
	};

	scrollDetectorInit = function () {
		$(selectors.element).each((i, el) => {
			new ScrollDetector(el);
		});
	};

	class ScrollDetector {
		constructor(element) {

			this.$element = $(element);
			if (this.$element.length) {
				this.init();
				this.resize();
				this.bind();
				this.scroll();
			}
		}

		init() {
			this.inView = false;
		}

		resize() {
			this.offY = this.$element.offset().top;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}


		scroll() {

			var scroll = window.scrollY;

			if (scroll + $(window).outerHeight() > this.offY && !this.inView) {
				this.inView = true;
				this.$element.trigger('scrolled-into-view');
			}
			if (scroll + $(window).outerHeight() < this.offY && this.inView) {
				this.inView = false;
				this.$element.trigger('scrolled-out-of-view');
			}

		}

	}

})(jQuery);

var scrollDetectorInit$1 = scrollDetectorInit;

var countersInit;

(function ($) {

	const selectors = {
		counter: '[data-counter]',
	};

	countersInit = function () {

		$(selectors.counter).each((i, el) => {
			new Counter(el);
		});

	};

	class Counter {

		constructor(el) {

			this.$counter = $(el);

			if (this.$counter.length) {
				this.init();
				this.bind();
			}
		}

		init() {
			this.time = 2000;
			this.$counter.text('0');

		}
		bind() {
			// const self = this;
			this.count = this.count.bind(this);
			this.$counter.on('scrolled-into-view', (e) => { this.count(); });
		}

		count(el) {

			var counter_value = this.$counter.attr('data-count-to');
			var target_num = parseInt(counter_value);

			var interval = this.time / target_num;
			var current_num = 0;

			var is_large_number = interval < 5;

			var step = is_large_number ? 10 : 1;
			interval = is_large_number ? 10 * interval : interval;

			var timer = setInterval(() => {

				if (current_num >= target_num) {
					var formatted = (target_num >= 1000) ? target_num.toString().slice(0, -3) + '.' + target_num.toString().substr(target_num.toString().length - 3) : target_num;
					this.$counter.text(formatted);
					clearInterval(timer);
					return;
				}

				var formatted = (current_num >= 1000) ? current_num.toString().slice(0, -3) + '.' + current_num.toString().substr(current_num.toString().length - 3) : current_num;

				this.$counter.text(formatted);
				current_num += step;

			}, interval);

		}

	}

})(jQuery);


var countersInit$1 = countersInit;

function galleryInit() {
	(function ($) {

		$('.c-post-content .gallery').each(function (i) {
			$(this).find('.gallery-item').each(function () {

				$(this).find('.gallery-icon a').attr('data-fancybox', 'post-gallery-' + i);

				if ($(this).find('.wp-caption-text')) {
					var captionText = $(this).find('.wp-caption-text').html();
					$(this).find('.gallery-icon a').attr('data-caption', captionText);
				}
			});
		});

	})(jQuery);
}

var placeholderInit;

(function ($) {

	const selectors = {
		wrap: '[data-placeholder]',
		input: '[data-placeholder-input]',
	};

	placeholderInit = function () {

		$(selectors.wrap).each((i, el) => {
			new Placeholder(el);
		});

	};

	class Placeholder {

		constructor(el) {

			this.$wrap = $(el);

			if (this.$wrap.length) {
				this.init();
				this.bind();
			}
		}

		init() {
			this.$input = $(selectors.input, this.$wrap);
			this.change();

		}
		bind() {
			// const self = this;
			this.change = this.change.bind(this);
			this.$input.on('change', (e) => { this.change(); });
		}

		change(el) {

			var val = '';

			if (this.$input.is('select')) {
				val = this.$input.find(':selected').text();
			}
			else {
				val = this.$input.val();
			}

			if (val) {
				this.$wrap.addClass('has-val');
			}
			else {
				this.$input.trigger('blur');
				this.$wrap.removeClass('has-val');

			}

		}

	}

})(jQuery);


var placeholderInit$1 = placeholderInit;

var slickInit;

(function ($) {

	const selectors = {
		'prevArrow': '[data-prev-arrow]',
		'nextArrow': '[data-next-arrow]',
	};

	slickInit = function () {

		new SlickSlider('.c-home-banner__slider', {
			fade: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 1500,
			arrows: false,
			pauseOnHover: false,
			dots: true,
			loop: true,
			events: {
				init: function (e, slick) {
					setTimeout(_ => {
						slick.$slides.eq(0).addClass('is-in-view');
					}, 10);

				},
				beforeChange: function (e, slick, currentSlide, nextSlide) {
					slick.$slides.eq(nextSlide).addClass('is-in-view');
					slick.$dots.children().removeClass('before-current');
					if (nextSlide > 0) slick.$dots.children().eq(currentSlide).addClass('before-current');
				},
				afterChange: function (e, slick, currentSlide) {
					slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
				}
			}
		});

		new SlickSlider('.c-home-intro__photos', {
			fade: true,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			arrows: true,
			pauseOnHover: false,
			dots: true,
			loop: true,
			prevArrow: $(selectors.prevArrow, $('.c-home-intro__photos').closest('section')),
			nextArrow: $(selectors.nextArrow, $('.c-home-intro__photos').closest('section')),
		});

		new SlickSlider('.c-news-slider', {
			arrows: false,
			dots: true,
			mobileFirst: true,
			loop: true,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 900,
					settings: 'unslick'
				}
			]
		});

	};

	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {

			this.onResize = this.onResize.bind(this);

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

		}

		init() {
			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}

})(jQuery);


var slickInit$1 = slickInit;

var fixtoInit;

(function ($) {

	const selectors = {
		box: '[data-fixto]',
		content: '[data-fixto-content]'
	};


	fixtoInit = function () {
		$(selectors.box).each((i, el) => {
			new Fixto(el);
		});
	};

	class Fixto {
		constructor(element) {
			this.box = element;
			this.content = $(selectors.content, this.box).get(0);

			if ($(this.content).length) {
				this.init();
			}

		}
		init() {

			const self = this;

			self.isActive = true;
			self.fromWidth = $(self.box).attr('data-from') ? parseInt($(self.box).attr('data-from')) : 0;

			self.offTop = window.scrollOffset ? window.scrollOffset : 0;
			self.offTop += $(self.box).attr('data-offset') ? parseInt($(self.box).attr('data-offset')) : 0;

			self.fixto = fixto.fixTo(this.content, this.box, {
				top: self.offTop,
				useNativeSticky: false,
				mind: '.c-top-bar'
			});

			this.bind();
			this.resize();
		}

		bind() {
			this.resize = this.resize.bind(this);
			$(window).on('resize', this.resize);
		}

		resize() {

			if (!this.fromWidth) return;
			if (window.outerWidth < this.fromWidth && this.isActive) {
				this.pause();
			}
			else if (window.outerWidth >= this.fromWidth && !this.isActive) {
				this.resume();
			}

		}

		pause() {
			this.isActive = false;
			this.fixto.stop();
		}

		resume() {
			this.isActive = true;
			this.fixto.start();

		}
	}

})(jQuery);


var fixtoInit$1 = fixtoInit;

var mieszkaniaTableInit;

(function ($) {

	const selectors = {
		box: '[data-mieszkania-table]',
		fixed: '[data-mieszkania-table-fixed]',
		table: '[data-mieszkania-table-regular]'
	};


	mieszkaniaTableInit = function () {
		$(selectors.box).each((i, el) => {
			new MieszkaniaTable(el);
		});
	};

	class MieszkaniaTable {
		constructor(element) {
			this.$box = $(element);

			if (this.$box.length) {
				this.init();
			}

		}
		init() {

			this.$table = $(selectors.table, this.$box);
			this.$header = $(selectors.fixed, this.$box);

			this.bind();
			this.scroll();
			this.resize();
			this.copyHeading();
		}

		bind() {

			const self = this;

			this.resize = this.resize.bind(this);
			this.scroll = this.scroll.bind(this);
			this.copyHeading = this.copyHeading.bind(this);
			this.onFixedHeadingCellClicked = this.onFixedHeadingCellClicked.bind(this);

			$(window).on('resize', this.resize);
			$(window).on('scroll', this.scroll);

			$('tbody td', this.$table).click(this.onTableRowClicked);
			$('tbody td a', this.$table).click((e) => { e.stopPropagation(); });

			$('thead td', this.$header).click(function () { self.onFixedHeadingCellClicked(this); });
			$('thead td', this.$table).click(this.copyHeading);
		}

		resize() {

			const self = this;

			self.$header.css('width', self.$table.outerWidth());
			self.$table.find('thead td').each((i, el) => {
				self.$header.find('thead td').eq(i).css('width', $(el).outerWidth());
			});

		}

		scroll() {

			const scroll = $(window).scrollTop() + $('.c-top-bar').outerHeight();
			const minScroll = this.$table.offset().top;
			const maxScroll = this.$table.offset().top + this.$table.outerHeight() - this.$header.outerHeight();


			if (scroll > minScroll && scroll < maxScroll) {
				this.$header.addClass('is-fixed');
			}
			else {
				this.$header.removeClass('is-fixed');
			}

		}

		onTableRowClicked() {
			var btn = $(this).closest('tr').find('.c-mieszkania-table__cell--btn a');
			if (btn.length) {
				window.location.href = btn.attr('href');
			}
		}

		copyHeading() {
			const self = this;
			$('thead td', self.$table).each((i, el) => {
				const idx = $(el).index();
				$('thead td', self.$heading).eq(idx).attr('class', $(el).attr('class'));
				$('thead td', self.$heading).eq(idx).html($(el).html());
			});
		}

		onFixedHeadingCellClicked(el) {
			const idx = $(el).index();
			$('thead td', this.$table).eq(idx).trigger('click');
		}

	}

})(jQuery);


var mieszkaniaTableInit$1 = mieszkaniaTableInit;

var searchFormInit;

(function ($) {

	const selectors = {
		form: '[data-search-form]',
		clearCheckbox: '[data-clear-filters]',
	};


	searchFormInit = function () {
		$(selectors.form).each((i, el) => {
			new SearchForm(el);
		});
	};

	class SearchForm {
		constructor(element) {
			this.$form = $(element);

			if (this.$form.length) {
				this.init();
			}

		}
		init() {

			this.$clearCheckbox = $(selectors.clearCheckbox, this.$form);

			this.bind();
		}

		bind() {
			this.clearFilters = this.clearFilters.bind(this);
			this.$clearCheckbox.on('change', this.clearFilters);
		}

		clearFilters() {
			// this.$clearCheckbox.prop('checked', false);

			$('[type="checkbox"]', this.$form).each((i, el) => {
				$(el).prop('checked', false);
			});

			$('select', this.$form).each((i, el) => {
				$(el).find('option[value=""]').prop('selected', true);
				$(el).trigger('change');
			});

			$('.noUi-target', this.$form).each((i, el) => {
				el.noUiSlider.set([el.noUiSlider.options.range.min, el.noUiSlider.options.range.max]);
			});

		}

	}

})(jQuery);


var searchFormInit$1 = searchFormInit;

var googleMapInit;

(function ($) {

	const selectors = {
		wrapper: '[data-google-map]',
		map: '[data-google-map-map]',
	};


	googleMapInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new GoogleMap(el);
		});
	};

	class GoogleMap {
		constructor(element) {

			this.$wrap = $(element);
			this.$map = $(selectors.map, this.$wrap);

			if (this.$map.length) {
				this.init();
			}

		}
		init() {

			const self = this;

			self.max_zoom = 15;

			var latLng = {
				lat: parseFloat(self.$map.attr('data-lat')),
				lng: parseFloat(self.$map.attr('data-lng'))
			};


			// Create gerenic map.
			var mapArgs = {
				zoom: self.$map.data('zoom') || self.max_zoom,
				maxZoom: self.max_zoom,
				// center: latLng,
				mapTypeId: self.$map.attr('data-type') || 'roadmap',
				styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
			};

			self.googleMap = new google.maps.Map(self.$map[0], mapArgs);

			var bounds = new google.maps.LatLngBounds();

			if ($('#inwestycja-location', self.$wrap).length) {

				var latLng = new google.maps.LatLng(
					parseFloat($('#inwestycja-location', self.$wrap).attr('data-lat')),
					parseFloat($('#inwestycja-location', self.$wrap).attr('data-lng'))
				);

				self.investmentMarker = new google.maps.Marker({
					position: latLng,
					map: self.googleMap,
					cursor: 'default',
					icon: {
						url: wp_params.theme_url + '/assets/img/map-marker-investment.svg?v=1.1',
						size: new google.maps.Size(261, 134),
						anchor: new google.maps.Point(52, 110)
					}
				});

				bounds.extend(latLng);
			}


			if ($('#sprzedaz-location', self.$wrap).length) {

				var latLng = new google.maps.LatLng(
					parseFloat($('#sprzedaz-location', self.$wrap).attr('data-lat')),
					parseFloat($('#sprzedaz-location', self.$wrap).attr('data-lng'))
				);

				self.sprzedazMarker = new google.maps.Marker({
					position: latLng,
					map: self.googleMap,
					cursor: 'default',
					icon: {
						url: wp_params.theme_url + '/assets/img/map-marker-sprzedaz.svg',
						size: new google.maps.Size(261, 134),
						anchor: new google.maps.Point(52, 110)
					}
				});

				bounds.extend(latLng);

			}


			self.googleMap.fitBounds(bounds); //auto-zoom
			self.googleMap.panToBounds(bounds); //auto-center

			var zoom = self.googleMap.getZoom();
			self.googleMap.setZoom(zoom > self.max_zoom ? self.max_zoom : zoom);

			// self.googleMap.panBy(90, 0);

		}
	}

})(jQuery);

var googleMapInit$1 = googleMapInit;

var poiGoogleMapInit;

(function ($) {

	const selectors = {
		wrap: '[data-poi-map]',
		map: '[data-poi-map-map]',
		link: '[data-poi-map-filter]',
		marker: '[data-poi-map-marker]'
	};


	poiGoogleMapInit = function () {
		$(selectors.wrap).each((i, el) => {
			new PoiGoogleMap(el);
		});
	};

	class PoiGoogleMap {
		constructor(element) {

			this.$wrap = $(element);

			if (this.$wrap.length) {
				this.init();
			}

		}
		init() {

			this.$map = $(selectors.map, this.$wrap);
			if (!this.$map.length) return;

			this.$links = $(selectors.link, this.$wrap);

			this.createMap();
			this.addMarkers();
			this.bind();

			this.$links.eq(0).trigger('click');

		}

		bind() {
			const self = this;
			this.onLinkClicked = this.onLinkClicked.bind(this);
			this.$links.on('click', function (e) { self.onLinkClicked(e, this); });
		}

		createMap() {

			const self = this;
			self.max_zoom = 15;

			var latLng = {
				lat: parseFloat(self.$map.attr('data-lat')),
				lng: parseFloat(self.$map.attr('data-lng'))
			};

			// Create gerenic map.
			var mapArgs = {
				zoom: self.$map.data('zoom') || self.max_zoom,
				maxZoom: self.max_zoom,
				center: latLng,
				mapTypeId: self.$map.attr('data-type') || 'roadmap',
				styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
			};

			self.googleMap = new google.maps.Map(self.$map[0], mapArgs);

			// Create marker instance.
			self.mainMarker = new google.maps.Marker({
				position: latLng,
				map: self.googleMap,
				cursor: 'default',
				icon: {
					url: wp_params.theme_url + '/assets/img/map-marker-investment.svg?v=1.1',
					size: new google.maps.Size(261, 134),
					anchor: new google.maps.Point(52, 110)
				}
			});

		}

		addMarkers() {
			const self = this;

			self.markers = {};

			$(selectors.marker, self.$wrap).each((i, marker) => {

				var cat = $(marker).attr('data-category');

				if (!self.markers[cat]) self.markers[cat] = [];

				var latLng = {
					lat: parseFloat($(marker).attr('data-lat')),
					lng: parseFloat($(marker).attr('data-lng'))
				};

				var _marker = new google.maps.Marker({
					position: latLng,
					cursor: 'default',
					icon: {
						url: wp_params.theme_url + '/assets/img/map-marker.svg',
						size: new google.maps.Size(24, 31),
						anchor: new google.maps.Point(12, 31)
					}
				});

				if ($(marker).html().trim().length) {

					var infowindow = new google.maps.InfoWindow({
						content: $(marker).html()
					});

					google.maps.event.addListener(_marker, 'mouseover', function () {
						infowindow.open(self.googleMap, _marker);
						document.activeElement.blur();
						return false;
					});
					google.maps.event.addListener(_marker, 'mouseout', function () {
						infowindow.close(self.googleMap, _marker);
						document.activeElement.blur();
						return false;
					});

				}

				self.markers[cat].push(_marker);
			});


		}


		onLinkClicked(e, link) {
			e.preventDefault();
			this.hideMarkers();
			this.showMarkers($(link).attr('data-poi-map-filter'));
			this.$links.removeClass('is-active');
			$(link).addClass('is-active');
		}

		hideMarkers() {
			const self = this;
			$.each(self.markers, (cat, markers) => {

				$.each(markers, (i, marker) => {
					marker.setMap(null);
				});

			});

		}
		showMarkers(cat) {
			const self = this;
			var bounds = new google.maps.LatLngBounds();

			var loc = new google.maps.LatLng(self.mainMarker.position.lat(), self.mainMarker.position.lng());
			bounds.extend(loc);

			$.each(self.markers[cat], (i, marker) => {
				marker.setMap(self.googleMap);
				var loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
				bounds.extend(loc);
			});
			self.googleMap.fitBounds(bounds); //auto-zoom
			self.googleMap.panToBounds(bounds); //auto-center

			var zoom = self.googleMap.getZoom();
			self.googleMap.setZoom(zoom > self.max_zoom ? self.max_zoom : zoom);
		}

	}

})(jQuery);

var poiGoogleMapInit$1 = poiGoogleMapInit;

var tableSortInit;

(function ($) {

	const selectors = {
		table: '[data-table-sort]',
		heading: '[data-table-sort-heading]',
	};

	tableSortInit = function () {
		$(selectors.table).each((i, el) => {
			new TableSort(el);
		});
	};

	class TableSort {

		constructor(table) {

			const self = this;

			self.$table = $(table);
			self.$headings = $(selectors.heading, self.$table);

			self.init();
			self.bind();
		}

		init() {
			const self = this;

			self.inverse = false;
			self.currentSortIdx = false;

			self.$headings.addClass('o-sortable-heading').wrapInner('<span class="o-sortable-heading__label"></span>').append('<span class="o-sortable-heading__icons"></span>').wrapInner('<span class="o-sortable-heading__wrap">');

			self.currentSortIdx = self.$headings.filter('.o-sortable-heading--sorted').length ? self.$headings.filter('.o-sortable-heading--sorted').index() : false;
			// self.$headings.eq(self.currentSortIdx).addClass('o-sortable-heading--sorted');

		}
		bind() {
			const self = this;
			self.$headings.click(function () { self.sort($(this)); });
		}

		sort($heading) {

			const self = this;

			var idx = $heading.index();
			self.inverse = (self.currentSortIdx === idx) ? !self.inverse : false;
			self.currentSortIdx = idx;
			var is_numeric = $heading.attr('data-numeric') !== undefined;


			self.$headings.removeClass('o-sortable-heading--sorted o-sortable-heading--sorted-inverse');
			$heading.addClass('o-sortable-heading--sorted');
			if (self.inverse) $heading.addClass('o-sortable-heading--sorted-inverse');

			self.$table.find('tbody td').filter(function () {
				return $(this).index() === self.currentSortIdx;
			}).sortElements(function (a, b) {

				var a_val = $(a).attr('data-sort-val') ? $(a).attr('data-sort-val') : $(a).text().trim();
				var b_val = $(b).attr('data-sort-val') ? $(b).attr('data-sort-val') : $(b).text().trim();

				if (a_val == b_val) return 0;

				if (is_numeric) {

					if (!a_val) a_val = self.inverse ? "-100" : (Number.MAX_SAFE_INTEGER).toString();
					if (!b_val) b_val = self.inverse ? "-100" : (Number.MAX_SAFE_INTEGER).toString();

					a_val = parseFloat(a_val.replaceAll(" ", "").replaceAll(",", "."));
					b_val = parseFloat(b_val.replaceAll(" ", "").replaceAll(",", "."));

					if (!a_val && a_val !== 0) a_val = self.inverse ? -99 : Number.MAX_SAFE_INTEGER - 1;
					if (!b_val && b_val !== 0) b_val = self.inverse ? -99 : Number.MAX_SAFE_INTEGER - 1;
				}

				return a_val > b_val ? (self.inverse ? -1 : 1) : (self.inverse ? 1 : -1);

			}, function () {
				return this.parentNode;
			});

		}


	}


})(jQuery);


var tableSortInit$1 = tableSortInit;



/**
 * jQuery.fn.sortElements
 * --------------
 * @author James Padolsey (http://james.padolsey.com)
 * @version 0.11
 * @updated 18-MAR-2010
 * --------------
 * @param Function comparator:
 *   Exactly the same behaviour as [1,2,3].sort(comparator)
 *   
 * @param Function getSortable
 *   A function that should return the element that is
 *   to be sorted. The comparator will run on the
 *   current collection, but you may want the actual
 *   resulting sort to occur on a parent or another
 *   associated element.
 *   
 *   E.g. $('td').sortElements(comparator, function(){
 *      return this.parentNode; 
 *   })
 *   
 *   The <td>'s parent (<tr>) will be sorted instead
 *   of the <td> itself.
 */
jQuery.fn.sortElements = (function () {

	var sort = [].sort;

	return function (comparator, getSortable) {

		getSortable = getSortable || function () { return this; };

		var placements = this.map(function () {

			var sortElement = getSortable.call(this),
				parentNode = sortElement.parentNode,

				// Since the element itself will change position, we have
				// to have some way of storing it's original position in
				// the DOM. The easiest way is to have a 'flag' node:
				nextSibling = parentNode.insertBefore(
					document.createTextNode(''),
					sortElement.nextSibling
				);

			return function () {

				if (parentNode === this) {
					throw new Error(
						"You can't sort elements if any one is a descendant of another."
					);
				}

				// Insert before flag:
				parentNode.insertBefore(this, nextSibling);
				// Remove flag:
				parentNode.removeChild(nextSibling);

			};

		});

		return sort.call(this, comparator).each(function (i) {
			placements[i].call(getSortable.call(this));
		});

	};

})();

var scrollTopInit;

(function ($) {

	const selectors = {
		link: '[data-scroll-top]',
	};

	scrollTopInit = function () {
		$(selectors.link).on('click', (e) => {
			e.preventDefault();
			$('html, body').animate({ 'scrollTop': 0 }, 1000);
		});
	};

})(jQuery);


var scrollTopInit$1 = scrollTopInit;

var popupInit;

(function ($) {

	const selectors = {
		popup: '[data-popup]',
		close: '[data-popup-close]',
		content: '[data-popup-content]',
	};

	popupInit = function () {

		$(selectors.popup).each((i, el) => {
			new Popup(el);
		});

	};

	class Popup {

		constructor(el) {

			this.$popup = $(el);

			if (this.$popup.length) {
				this.init();
				this.bind();
			}
		}

		init() {
			this.id = this.$popup.attr('id');
			this.$content = $(selectors.content, this.$popup);
			this.$closeBtn = $(selectors.close, this.$popup);

			this.$trigger = $('[href="#' + this.id + '"]');

		}
		bind() {

			const self = this;

			this.open = this.open.bind(this);
			this.close = this.close.bind(this);
			this.onTriggerClicked = this.onTriggerClicked.bind(this);

			this.$trigger.on('click', function (e) { self.onTriggerClicked(e, this); });
			this.$popup.on('click', this.close);
			this.$closeBtn.on('click', (e) => { e.preventDefault(); self.close(); });

			this.$content.on('click', (e) => { e.stopPropagation(); });
		}

		onTriggerClicked(e, trigger) {
			e.preventDefault();

			var content = $(trigger).attr('data-popup-form-text') || '';

			$('textarea', this.$content).text(content);

			this.open();

		}

		close() {
			this.$popup.stop().fadeOut();
		}
		open() {
			this.$popup.stop().fadeIn();
		}

	}

})(jQuery);


var popupInit$1 = popupInit;

var scrollLinksInit;

(function ($) {

	const selectors = {
		link: '[data-scroll-top]',
		scrollInidicator: '[data-scroll-indicator]'
	};

	scrollLinksInit = function () {
		$(selectors.link).on('click', (e) => {
			e.preventDefault();
			$('html, body').animate({ 'scrollTop': 0 }, 1000);
		});

		$('body').on('click', selectors.scrollInidicator, function (e) {
			e.preventDefault();

			var $next_section;
			if ($(this).attr('data-target')) {
				$next_section = $($(this).attr('data-target'));
			}
			if (!$next_section.length) {
				$next_section = $(this).closest('section').nextAll('section');
			}

			if ($next_section.length) {

				$next_section = $next_section.first();

				const header_height = $(window).width >= 900 ? 70 : 70;

				const win_height = $(window).height() - header_height;

				var offTop = $next_section.offset().top - header_height;
				// if ($next_section.outerHeight() < win_height) {
				// offTop -= (win_height - $next_section.outerHeight()) / 2;
				// }

				$('html, body').stop().animate({ scrollTop: offTop });
			}
		});


		$('a[href^="#"]:not([href="#"])').on('click', function (e) {
			e.preventDefault();

			const target_id = $(this).attr('href').slice(1);
			const $target = $('#' + target_id + ', [data-id="' + target_id + '"]').filter(':visible');

			if ($target.length) {
				history.replaceState({}, '', this.href);
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 70 }, 700);

			}

		});

	};

})(jQuery);


var scrollLinksInit$1 = scrollLinksInit;

var hashHandlerInit;

(function ($) {

	hashHandlerInit = function () {

		const url = window.location.href;
		const target = window.location.hash.replace('#', '');
		window.location.hash = "";

		if (target) $(document).ready(_ => {

			const $target = $('#' + target + ', [data-id="' + target + '"]').filter(':visible');

			if ($target.length) {
				history.replaceState({}, '', url);
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 70 }, 700);
			}

		});

	};

})(jQuery);

var hashHandlerInit$1 = hashHandlerInit;

// import favInit from './modules/fav';
// import mapInit from './modules/map-tooltip';
(function ($) {

	$.fancybox.defaults.buttons = [
		// "zoom",
		//"share",
		"slideShow",
		//"fullScreen",
		//"download",
		"thumbs",
		"close"
	];

	hashHandlerInit$1();

	$(document).ready(function () {

		$('a[href="#"]').click((e) => { e.preventDefault(); });

		documentInit$1();
		mobileNavInit$1();
		navInit$1();
		scrollTopInit$1();
		scrollLinksInit$1();

		noUiSliderInit$1();
		tabsInit$1();
		countersInit$1();
		placeholderInit$1();
		slickInit$1();
		tableSortInit$1();
		popupInit$1();

		googleMapInit$1();
		poiGoogleMapInit$1();

		// mapInit();

		scrollDetectorInit$1();

		galleryInit();
		fixtoInit$1();
		mieszkaniaTableInit$1();
		searchFormInit$1();
		// favInit();


		$(document).trigger('hp-plugins-loaded');

		$(document.body).addClass('is-loaded');

		$(window).trigger('resize');
		$(window).trigger('scroll');

	});

})(jQuery);

}());
